var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 0.25H3.75C1.68 0.25 0 1.93 0 4V16C0 18.07 1.68 19.75 3.75 19.75H11.75C13.82 19.75 15.5 18.07 15.5 16V4C15.5 1.93 13.82 0.25 11.75 0.25ZM14 16C14 17.24 12.99 18.25 11.75 18.25H3.75C2.51 18.25 1.5 17.24 1.5 16V4C1.5 2.76 2.51 1.75 3.75 1.75H11.75C12.99 1.75 14 2.76 14 4V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.75H7.75C8.16 6.75 8.5 6.41 8.5 6C8.5 5.59 8.16 5.25 7.75 5.25H4.75C4.34 5.25 4 5.59 4 6C4 6.41 4.34 6.75 4.75 6.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.25H4.75C4.34 9.25 4 9.59 4 10C4 10.41 4.34 10.75 4.75 10.75H10.75C11.16 10.75 11.5 10.41 11.5 10C11.5 9.59 11.16 9.25 10.75 9.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.25H4.75C4.34 13.25 4 13.59 4 14C4 14.41 4.34 14.75 4.75 14.75H10.75C11.16 14.75 11.5 14.41 11.5 14C11.5 13.59 11.16 13.25 10.75 13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.be65aadcd961f799cc84a271f74eef49.svg";
export { ForwardRef as ReactComponent };